var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGranularity = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m30.329 26.443 11.932 6.89V47.11L30.329 54l-11.932-6.89V33.333l11.932-6.889ZM17.731 5.974l11.932 6.889V26.64L17.731 33.53 5.8 26.64V12.864l11.932-6.89Z",
  stroke: "#1FDAFF",
  strokeWidth: 1.6
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m42.538 5.28-.4-.23-.4.23-11.932 6.89-.4.23v14.703l.4.23 11.932 6.89.4.23.4-.23 11.933-6.89.4-.23v-2.21h-1.6v1.286l-11.133 6.427-11.132-6.427V13.325l11.132-6.428 11.133 6.428v1.38h1.6V12.402l-.4-.231-11.933-6.89Z",
  fill: "#1FDAFF"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M53.199 16.6h1.6v1.6h-1.6z"
})));
export default SvgGranularity;